<!-- The comment component -->
<template>
    <v-dialog v-model="GET_comment.show" scrollable max-width="500px">
        <v-card color="grey lighten-2">
            <v-card-title class="grey darken-3 white--text">Add Comment</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 250px;" class="mt-5">
                <v-textarea label="Comment" v-model="form.comment" filled hide-details background-color="white" dense auto-grow rows="4" clearable></v-textarea>
                <v-checkbox color="grey darken-1" hide-details v-model="form.private" label="Private Comment"></v-checkbox>
                <!-- <pre>{{ GET_comment }}</pre>
                <pre>{{ form }}</pre> -->
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="text-right">
                <v-spacer />
                <v-btn color="grey lighten-1" @click="closeComment">Close</v-btn>
                <v-btn v-if="GET_comment.action === 'New'" color="black white--text" @click="saveComment">Save</v-btn>
                <v-btn v-else color="black white--text" @click="updateComment">Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        data: () => ({
            form: {
                id: '',
                comment: '',
                private: true,
                docLink: {
                    collection: null,
                    documentId: null
                }
            }
        }),
        computed: {
            ...mapGetters({
                GET_comment: 'comment_store/GET_comment',
                GET_commentResult: 'comment_store/GET_commentResult'
            }),
        },
        watch: {
            GET_comment: {
                handler() {
                    var t = this;
                    if (t.GET_comment.data !== undefined) {
                         t.form = JSON.parse(JSON.stringify(t.GET_comment.data));
                    } else {
                        // do nothing as nothing sent yet
                    }
                }, deep: true
            }
        },
        methods: {
            ...mapActions({
                ACT_commentResult: 'comment_store/ACT_commentResult',
            }),
            closeComment() {
                this.MIX_comment({ show: false, action: 'New', data: { } })
            },
            saveComment: async function () {
                var t = this;
                var createDocumentResult = await t.MIX_createDocument('comments', t.form);
                if (createDocumentResult.code === 1) {  
                    t.ACT_commentResult({ field: t.GET_comment.field, value: t.comment, id: t.GET_comment.id, commentId: createDocumentResult.data.id }); // Save Comment
                    t.MIX_comment({ show: false, action: 'New', data: { } })
                    t.MIX_alert(1, 'Comment Saved', createDocumentResult.data, null);
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not save Comment', null, createDocumentResult.error); 
                }
            },
            updateComment: async function () {
                var t = this;
                var commentId = t.form.id;
                delete t.form.id
                var updateDocumentResult = await t.MIX_updateDocumentFieldsById('comments', commentId, t.form)
                if (updateDocumentResult.code === 1) {
                    t.MIX_alert(1, 'Comment Updated', updateDocumentResult.data, null);
                        t.MIX_comment({ show: false, action: 'New', data: { } })
                } else {
                    t.MIX_alert(-1, 'ERROR - Could not update Comment', null, updateDocumentResult.error); 
                }
            }
        },
        mounted() {
            var t = t;
        }
    }
</script>